import { VolumeScalarGenerator } from "./ScalarGenerator";

export const generatorSingleton = new VolumeScalarGenerator();
